import React, { useEffect, useRef, useState } from 'react';
import { formatDuration } from 'shared/utils/helpers';

export const CallDuration = ({ callStartedAt }: { callStartedAt: number }) => {
  const [duration, setDuration] = useState<string | null>(null);
  const durationInterval = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!callStartedAt) {
      if (!durationInterval.current) return;
      clearInterval(durationInterval.current);

      return;
    }
    durationInterval.current = setInterval(() => {
      const now = new Date();
      const differenceInSeconds = Math.floor(
        (now.getTime() + now.getTimezoneOffset() * 60 * 1000 - callStartedAt) / 1000,
      );

      setDuration(formatDuration(differenceInSeconds * 1000));
    }, 1000);

    return () => {
      if (!durationInterval.current) return;
      clearInterval(durationInterval.current);
    };
  }, [callStartedAt]);

  if (duration) {
    return <div className="CallDuration">{duration}</div>;
  }
  return null;
};
